export default __webpack_public_path__ + "static/adventurepark-61f647c01dacc56e3844d616e7168dad.svg";